import { render, staticRenderFns } from "./ChannelStatusWidget.vue?vue&type=template&id=30f51cc2&scoped=true"
import script from "./ChannelStatusWidget.vue?vue&type=script&lang=js"
export * from "./ChannelStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ChannelStatusWidget.vue?vue&type=style&index=0&id=30f51cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f51cc2",
  null
  
)

export default component.exports